import OrganisationsSelect from '../../../elements/Select/Organistaions'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'

function OrderList(props) {
  const { listOrders, fetchingOrders, fetchOrders, companyOrder, onChangeCompanyOrder } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      width: 180,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Code',
      accessor: 'code',
      width: 100,
      Cell: ({ value, original }) => (
        <Link target={'_blank'} to={`/purchasing/Order/${original._key}/update`}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Vendor',
      accessor: 'vendor.fn',
      width: 320,
      style: { paddingLeft: 20, alignment: 'left' },
    },
    {
      Header: 'Vendor Rep',
      accessor: 'vendorRep.fn',
      width: 200,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Title',
      accessor: 'title',
      style: { paddingLeft: 20, alignment: 'left' },
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Type',
      accessor: 'orderType[0]',
      hideable: true,
      hideDefault: true,
      width: 120
    },
    {
      Header: 'Category',
      accessor: 'orderType[1]',
      hideable: true,
      hideDefault: true,
      width: 120
},
    { Header: 'Order Date', accessor: 'date', width: 120, Cell: DateCell },
    {
      Header: 'Validity End',
      accessor: 'validityEnd',
      Cell: DateCell,
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Delivery Date', accessor: 'delivery.date', hideable: true, hideDefault:true, Cell: DateCell },

    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Currency', accessor: 'currency', width: 100 },
    {
      Header: 'Amount (EX)',
      accessor: 'subTotal.net',
      style: { textAlign: 'right' },
      width: 120,
      Cell: MoneyCell,
    },
    { Header: 'Status', accessor: 'status', width:120, Cell: StatusCell },
    { Header: 'Payment Status', accessor: 'paymentStatus', Cell: StatusCell, hideable: true, hideDefault: true },
  ]
  return (
    <CustomTable
      data={listOrders}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetchingOrders}
      fetch={fetchOrders}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={companyOrder}
          onChange={onChangeCompanyOrder}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      defaultSorted={[
        {
          id: 'date',
          desc: true,
        },
      ]}
      //style={{ minHeight: '512px', fontSize: 11 }}
    />
  )
}

OrderList.propTypes = {
  listOrders: PropTypes.any,
  fetchingOrders: PropTypes.any,
  fetchOrders: PropTypes.any,
  companyOrder: PropTypes.any,
  onChangeCompanyOrder: PropTypes.any,
}
OrderList.defaultProps = {}

export default OrderList
